import React from 'react';
import './ListTableHeaderSelectAll.scss';
import { withListTableContext } from '../ListTableContextConsumer';
import { getClass } from '../../_lib/helper';

export type ListTableHeaderSelectAllProps = {
  onSelectAllAvailable: (isSelect: boolean) => React.MouseEventHandler;
  /** @Ignore From DataTableContext */
  countItemsAvailable?: number;
  /** @Ignore From DataTableContext */
  isAllAvailableSelected?: boolean;
  /** @Ignore From DataTableContext */
  countSelectable: number;
};

function ListTableHeaderSelectAllMessage({ children, className }: any) {
  return (
    <div className={getClass('elmo-listtable__select-message', className)}>
      {children}
    </div>
  );
}

function ListTableHeaderSelectAll({
  countItemsAvailable,
  onSelectAllAvailable,
  isAllAvailableSelected,
  countSelectable,
}: ListTableHeaderSelectAllProps) {
  if (isAllAvailableSelected) {
    return (
      <ListTableHeaderSelectAllMessage className="all-selected">
        All {countItemsAvailable} items are selected.&nbsp;
        <span onClick={onSelectAllAvailable(false)}>Clear Selection</span>
      </ListTableHeaderSelectAllMessage>
    );
  }

  return (
    <ListTableHeaderSelectAllMessage>
      All {countSelectable} items selected on this page.&nbsp;
      <span onClick={onSelectAllAvailable(true)}>
        Select all {countItemsAvailable} items.
      </span>
    </ListTableHeaderSelectAllMessage>
  );
}

export default withListTableContext(ListTableHeaderSelectAll);
